module.exports = __webpack_public_path__ + "static/media/screenshot-9.70aa6459.png";